<div class="result-card row no-gutters" id="go-to-doctor-from-search" routerLinkActive="router-link-active">
  <div (click)="onDoctorClick()"
       [class.align-items-start]="toggleSlots"
       class="col-lg-7 d-flex flex-wrap flex-sm-nowrap position-relative mb-3 mb-lg-0 cursor-pointer">
    <div class="doctor-info__wrapper">
      <div class="doctor-image">
        <img loading="lazy" (error)="updateUrl($event)" [src]="apiUrl+'/files/profile_pic/' + doctor.userId + '?size=s'"
             alt="" class="mb-3">
        <div class="d-flex justify-content-center">
        </div>
      </div>
      <div class="doctor-info">
        <h6 class="name mb-3 mb-lg-1">{{doctor.fullName}}</h6>
        <div *ngIf="doctor.country" class="country">
          {{doctor.country}} - {{doctor?.foreignDoctorClinic}}
        </div>
        <div *ngIf="doctor.clinic">
          <span
              class="clinic-route">{{doctor?.clinic?.name}}</span>
        </div>
        <div class="d-flex align-items-center overal-reviews-container">
          <div class="overal-reviews d-flex">
            <app-rating-stars [rating]="doctor.raitingavg"></app-rating-stars>
          </div>
          <span class="rating-score">{{doctor.raitingavg}}</span>
          <a class="all-reviews"
             routerLink="/eqimi/{{doctor.fullName.replace(' ', '-')}}/{{doctor.userId}}">{{doctor.ratingCount}}
            {{'reviews' | translate}}</a>
        </div>
        <ng-container *ngIf="doctor.providers.length > 0">
          <div class="insurance-provider mb-3">
            {{'insurance-provider' | translate}}
          </div>
        </ng-container>
        <ng-container *ngFor="let doctorServices of doctor.doctorServicesBySpecialty">
          <div class="d-flex flex-wrap info-texts">
            <span class="muted" style="width: 70%; white-space: normal">{{doctorServices.serviceName}}</span>
            <span class="val font-weight-bold">{{doctorServices.price}} ₾</span>
          </div>
        </ng-container>
        <div *ngIf="doctor.refDoctorLanguageEntities.length" class="d-flex info-texts mb-3 mb-lg-0 flex-wrap">
          <span class="muted">{{'language' | translate}}:</span>
          <span *ngFor="let language of doctor.refDoctorLanguageEntities" class="mr-3">
                        {{language.languageName}}
                    </span>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-5 time-table-col position-relative">
    <app-time-slot (navigateToClosestAvailableDate)="navigateToClosestAvailableDate.emit($event)"
                   (navigateToSelectedDoctor)="goToDoctorPublicProfile($event)"
                   (onServiceTypeSelect)="serviceTypeChanged($event)"
                   (onSpecialtyChange)="specialtyChanged($event)"
                   (reinitializeSearch)="reinitializeSearch($event)"
                   (doctorUpdated)="doctorUpdated($event)"
                   [doctorClicked]="doctorClicked.asObservable()"
                   [doctor]="doctor"
                   [renderDates]="renderDates"
                   [selectedServiceType]="selectedServiceType"
                   [selectedSpeciality]="selectedSpeciality">
    </app-time-slot>
  </div>
</div>